import React from "react";
import { ChevronRight } from "lucide-react";

const DashboardRecentRow = ({ children, onClick, ariaLabel }) => (
    <button
        type="button"
        onClick={onClick}
        aria-label={ariaLabel}
        className="group flex w-full min-w-0 items-start gap-3 border-b border-slate-100 px-3.5 py-3 text-left transition-colors odd:bg-slate-50 even:bg-white hover:bg-amber-50/50 focus:outline-none focus-visible:bg-indigo-50 focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-indigo-200"
    >
        <div className="flex min-w-0 flex-1 items-start justify-between gap-3">
            {children}
        </div>
        <ChevronRight
            size={17}
            className="mt-1 shrink-0 text-slate-400 transition-transform group-hover:translate-x-0.5 group-hover:text-indigo-600"
            aria-hidden="true"
        />
    </button>
);

export default DashboardRecentRow;
